import axios from 'axios'

const getAdditionalHeaders = () => {
	const langs = {
		rus: 'ru',
		kz: 'kz',
	}

	let lang = 'ru'
	try {
		lang = localStorage.getItem('lang')
	} catch (error) {}

	return { 'Accept-Language': langs[lang] }
}

const externalInstance = axios.create({
	baseURL: process.env.REACT_APP_SPO_API_URL,
	withCredentials: false,
	headers: getAdditionalHeaders(),
})

externalInstance.interceptors.request.use(
	(config) => {
		const additionalHeaders = getAdditionalHeaders()
		return { ...config, headers: { ...config.headers, ...additionalHeaders } }
	},
	(error) => Promise.reject(error)
)

export const getSpoList = (params) => {
	return externalInstance.get('/spo/list', { params })
}